import { createAction } from "redux-starter-kit";

const actions = {
  exportHabit: {
    request: createAction("admin/exportHabit/request"),
    success: createAction("admin/exportHabit/success"),
    failure: createAction("admin/exportHabit/failure"),
  },
};

export default actions;
